import React from 'react';
import PropTypes from 'prop-types';
import './answerResult.css';

const AnswerResult = props => {
  const {
    answerText,
    answerComment,
    answerValue,
    value,
    answerCorrect,
    answerStatistic,
    testType
  } = props;

  return (
    <label
      className={`answer answer_result 
        ${
          answerCorrect && testType === 1
            ? 'answer_result_success'
            : answerValue === value && !answerCorrect && testType === 1
            ? 'answer_result_error'
            : ''
        }`}
    >
      <div className="answer__text">{answerText}</div>
      {testType === 1 && (
        <div className="answer__statistic">{answerStatistic}%</div>
      )}
      {answerValue === value && testType === 1 && (
        <div
          className="answer__comment"
          dangerouslySetInnerHTML={{ __html: answerComment }}
        ></div>
      )}
    </label>
  );
};

AnswerResult.propTypes = {
  answerText: PropTypes.string.isRequired,
  answerComment: PropTypes.string.isRequired,
  answerValue: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  answerCorrect: PropTypes.bool.isRequired,
  answerStatistic: PropTypes.number.isRequired
};

export default AnswerResult;
